(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["how-it-work"] && !Shopify.designMode) return;
  try {
    
    const handlePlayVideo = (event) => {
    const containers = document.querySelectorAll(".how_it_work__swiper .how_it_work__swiper__video");
    const currentContainer = event.target.closest(".how_it_work__swiper__video")
    const currentVideo = currentContainer.querySelector("video")
    const currentBtn = currentContainer.querySelector("button")

    containers.forEach(container => {
      const video = container.querySelector("video")
      const btn = container.querySelector("button")
      if (video !== currentVideo) {
        btn.classList.add("muted")
        video.muted = true
      }
    })

    currentBtn.classList.toggle("muted")
    currentVideo.muted = !currentVideo.muted;

  }

  const howItWorkSlider = () => {
    new Swiper('.how_it_work__swiper', {
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          loop: false,
        },
        400: {
          slidesPerView: 1.5,
          loop: false,
        },
        600: {
          slidesPerView: 2.5
        },
        900: {
          slidesPerView: 3
        },
        1344: {
          slidesPerView: 3
        },
        1500: {
          slidesPerView: 3
        },
        1980: {
          slidesPerView: 3
        }
      },
      loop: true,
      spaceBetween: 16,
      freeMode: false,
      watchOverflow: true,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: '.how_it_work__controls .swiper-button-next',
        prevEl: '.how_it_work__controls .swiper-button-prev',
      },
      pagination: {
        el: ".how_it_work__swiper .swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });
  };

  document.addEventListener("DOMContentLoaded", function() {
    howItWorkSlider();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pads-tech"]) return;
  try {
    
  const bundleSlider = () => {
    new Swiper('.blundleSlider', {
      slidesPerView: 1.1,
      freeMode: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        600: {
          slidesPerView: 'auto',
        },
      },
      pagination: {
        el: '.blundleSlider .swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      watchOverflow: true,
      spaceBetween: 25,
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    bundleSlider();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["targets"] && !Shopify.designMode) return;
  try {
    
  const targetsSlider = () => {
    new Swiper('.targets__swiper', {
      spaceBetween: 24,
      slidesPerView: "auto",
      freeMode: true,
      watchOverflow: true,
      centerInsufficientSlides: true,
      pagination: {
        el: ".targets__dots",
        type: "bullets",
        clickable: true,
      },
    });
  };

  document.addEventListener("DOMContentLoaded", function() {
    targetsSlider();
  });

  } catch(e) { console.error(e); }
})();
})();
